import React, {FC, ReactElement, useEffect, useState} from 'react';
import {
    DeviceConfig,
    RecognizableAndTranslatableLanguage,
    TranslatableAndSpeakableLanguage
} from '../contexts/Configuration';
import DeviceSelector from './DeviceSelector';
import {Checkbox, Slider} from '@mui/material';
import {updatePanelConfiguration} from '../reducers/sessionReducer';

import './Controller.scss';
import LanguageSelector from './LanguageSelector';
import {useAppDispatch, useAppSelector} from '../hooks/storeHooks';
import AudioLevel, {AudioLevelAPI} from './AudioLevel';

export enum DeviceType {IN = 'in', OUT = 'out'}

const Controller: FC<ControllerProps> = ({deviceType, id}): ReactElement => {

    const isInputController = deviceType === DeviceType.IN;

    const [selectedLanguage, setSelectedLanguage] = useState<RecognizableAndTranslatableLanguage | TranslatableAndSpeakableLanguage | null>(null);
    const [gainLevel, setGainLever] = useState<number>(30);
    const [selectedDevice, setSelectedDevice] = useState<MediaDeviceInfo | null>();
    const [audioLevelAPIRef, setAudioLevelAPIRef] = useState<AudioLevelAPI | null>();
    const [onlyText, setOnlyText] = useState(false);

    const sessionStarted = useAppSelector((state) => state.session.sessionStarted);
    const autoDetectLang = useAppSelector((state) => state.session.autoDetectLang);
    const availableOutputDevicesAmount = useAppSelector((state) => state.session.availableOutputDevicesAmount);
    const transcriptionPanels = useAppSelector((state) => state.session.transcriptionPanels);
    const outputs = useAppSelector((state) => state.session.outputs);

    const isExtra = transcriptionPanels.find(p => id === p.id)?.isExtra || false;

    const [outputLevel, setOutputLevel] = useState<number>(70);

    const dispatch = useAppDispatch();
    useEffect(() => {
        //Si no hay mas devices para seleccionar && soy extra => checkByDefaultOnlyText
        const shouldCheckByDefaultTextOnly = isExtra && (outputs.filter(o => !o.textOnly).length > availableOutputDevicesAmount);
        if (!['panel_0', 'panel_1'].includes(id)) {
            // console.log('availableOutputDevicesAmount: ', availableOutputDevicesAmount)
            // console.log('outputs.filter(o => !o.textOnly).length: ', outputs.filter(o => !o.textOnly).length)
            // console.log(`${id} -> shouldCheckByDefaultTextOnly:`, shouldCheckByDefaultTextOnly)
            setOnlyText(shouldCheckByDefaultTextOnly);

            if (shouldCheckByDefaultTextOnly) {
                console.log('outputs', outputs)
            }
        }
    }, []);

    useEffect(() => {
        let deviceConfig: DeviceConfig = {
            type: deviceType,
            panelId: id
        };

        deviceConfig.language = selectedLanguage;
        deviceConfig.gain = gainLevel / 100;
        deviceConfig.device = selectedDevice;
        deviceConfig.audioLevelAPIRef = audioLevelAPIRef;

        if (isInputController) {
            deviceConfig.autoDetectLang = autoDetectLang;
        }
        if (!isInputController) {
            deviceConfig.textOnly = onlyText || false;
        }

        dispatch(updatePanelConfiguration(deviceConfig));
    }, [selectedLanguage, gainLevel, selectedDevice, onlyText, autoDetectLang]);


    return (
        <div className="controller-container">
            {/*<div>{`panel_id: ${id}`}</div>*/}
            {/* Dropdown de idiomas */}
            <LanguageSelector
                id={id}
                isInputSelector={isInputController}
                onLanguageSelected={(selected) => {
                    // if (isInputController) {
                    // console.log('1 -->', id, selected);
                    // }

                    setSelectedLanguage(selected);
                }}
            />
            {/* Dropdown de dispositivos */}
            <DeviceSelector kind={isInputController ? 'audioinput' : 'audiooutput'}
                            onDeviceSelected={(d) => setSelectedDevice(d)}
                            onlyTextEnabled={onlyText}
                            id={id}
            />

            {/* Controles del dispositivo: volumen, output level, etc */}
            <div className="controller-settings">
                <div className="level-control">
                    <div className="level-control-label">
                        Volume
                    </div>
                    <Slider className="level-control-vol"
                            aria-label="Volume"
                            value={gainLevel}
                            step={10}
                            onChange={(e, newValue) => setGainLever(newValue as number)}
                    />
                </div>
                {/*{isInputController && selectedDevice?.deviceId && (*/}
                {isInputController && (
                    <AudioLevel
                        onAudioLevelAPIReady={(api) => setAudioLevelAPIRef(api)}
                        isInputStream={isInputController}
                        deviceId={selectedDevice?.deviceId || null}
                    />
                )}
                {/*)}*/}
                {!isInputController && (
                    <div className="level-control">
                        <div className="level-control-label">
                            Text only
                        </div>
                        <div className="level-control-check">
                            <Checkbox checked={onlyText} disabled={sessionStarted}
                                      onClick={() => setOnlyText(!onlyText)}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

type ControllerProps = {
    deviceType: DeviceType;
    id: string;
}

export default Controller
